/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { PageRequestFromJSON, PageRequestToJSON, } from './PageRequest';
import { TagListEntryFromJSON, TagListEntryToJSON, } from './TagListEntry';
/**
 * Check if a given object implements the PagedResponseOfTagListEntry interface.
 */
export function instanceOfPagedResponseOfTagListEntry(value) {
    var isInstance = true;
    return isInstance;
}
export function PagedResponseOfTagListEntryFromJSON(json) {
    return PagedResponseOfTagListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfTagListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'size': !exists(json, 'size') ? undefined : json['size'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(TagListEntryFromJSON))
    };
}
export function PagedResponseOfTagListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'size': value.size,
        'metaData': MetaDataToJSON(value.metaData),
        'hasNext': value.hasNext,
        'hasPrevious': value.hasPrevious,
        'page': value.page,
        'nextPage': PageRequestToJSON(value.nextPage),
        'numberOfElements': value.numberOfElements,
        'previousPage': PageRequestToJSON(value.previousPage),
        'totalElements': value.totalElements,
        'entries': value.entries === undefined ? undefined : (value.entries.map(TagListEntryToJSON))
    };
}
